import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useRef } from "react";
import DataTable from "../../../../../Common/DataTable/DataTable";
import {
  DELETE_RESTAURANT_CATEGORY_REQUEST,
  GET_ALL_BOOKING_LOGS_REQUEST,
  GET_ALL_RESERVATION_LIST_REQUEST,
  GET_ALL_RESTAURANT_CATEGORY_LIST_REQUEST,
  PUT_ROOM_REASSIGN_REQUEST,
} from "../../../../../Utils/Constant";
import DataTableFooter from "../../../../../Common/DataTableFooter/DataTableFooter";
import { restaurantCategoryColumns } from "./RestaurantCategoryColumns";
import { useNavigate } from "react-router-dom";
import ConfirmationATM from "../../../../../Common/ConfirmationATM";
import DataTableHeader from "../../../../../Common/DataTableHeader/DataTableHeader";
import { hasDeleteAccess, hasEditAccess } from "../../../../../Common/CheckAccess";

const RestaurantCategoryTable = ({ setSelectedCategory }) => {
  const dispatch = useDispatch();

  const [categoryData, setCategoryData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [globalFilter, setGlobalFilter] = useState("");
  const [gloablFilterType, setGloablFilterType] = useState("name");
  const [openMenuId, setOpenMenuId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const navigate = useNavigate();

  const [permissions, setPermissions] = useState([]);
      
        const existingPermissions = localStorage.getItem("checkPermission");
      
        useEffect(() => {
          if (existingPermissions != undefined) {
            const parsedData = JSON.parse(existingPermissions);
            setPermissions(parsedData);
          }
        }, [existingPermissions]);
        
  const {
    categoryList,
    loading,
    addCategory,
    updateCategory,
    deleteCategory,
  } = useSelector((state) => state.restaurant);

  useEffect(() => {
    dispatch({
      type: GET_ALL_RESTAURANT_CATEGORY_LIST_REQUEST,
      payload: { page, limit: pageSize, sortBy, sortOrder, name: globalFilter },
    });
  }, [
    dispatch,
    page,
    pageSize,
    sortBy,
    sortOrder,
    addCategory,
    updateCategory,
    deleteCategory,
    globalFilter,
  ]);

  const handleDelete = (selectData) => {
    setSelectedUser(selectData);
    setShowDeleteModal(true);
  };

  useEffect(() => {
    if (categoryList?.data?.categories?.length) {
      const transformed = categoryList?.data?.categories?.map((data) => ({
        name: data.name || "N/A",
        description: data.description || "N/A",
        created_at: data.created_at?.split("T")[0] || "N/A",
        sub_Category: (
          <>
            <span
              className="btn"
              onClick={() => {
                navigate(`/restaurant/category/${data?.id}`);
              }}
            >
              View
            </span>
          </>
        ),
        actions: (
          <>
            {hasDeleteAccess(permissions, "restaurant") &&<button
              className="btn"
              data-toggle="modal"
              data-target="#deleteGuest"
              onClick={() => handleDelete(data)}
            >
              <i className="bi bi-trash text-danger"></i>
            </button>}
            <button
              data-bs-toggle="offcanvas"
              data-bs-target="#add-category"
              aria-controls="add-category"
              className="btn"
              disabled={!hasEditAccess(permissions, "restaurant")}
              onClick={() => setSelectedCategory(data)}
            >
              <i className="bi bi-pencil text-primary"></i>
            </button>
          </>
        ),
      }));

      setCategoryData(transformed);
    } else {
      setCategoryData([]);
    }
  }, [openMenuId, categoryList]);

  const handleSortChange = (sort) => {
    setSortBy(sort.id);
    setSortOrder(sort.desc ? "desc" : "asc");
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  // Extract total entries and total pages from API pagination info
  const totalEntries = categoryList?.data?.pagination?.totalResults || 0;
  const totalPages = categoryList?.data?.pagination?.totalPages || 1;

  const confirmDelete = () => {
    dispatch({
      type: DELETE_RESTAURANT_CATEGORY_REQUEST,
      payload: { id: selectedUser?.id },
    });
    setShowDeleteModal(false);
  };

  return (
    <div>
      <DataTableHeader
        pageSize={pageSize}
        setPageSize={setPageSize}
        globalFilter={globalFilter}
        setGlobalFilter={setGlobalFilter}
        setCurrentPage={setPage}
        gloablFilterType={gloablFilterType}
        setGloablFilterType={setGloablFilterType}
        flage="category"
      />
      <DataTable
        columns={restaurantCategoryColumns}
        data={categoryData}
        pageSize={pageSize}
        setPageSize={setPageSize}
        onSortChange={handleSortChange}
        isLoading={loading}
      />
      <DataTableFooter
        currentPage={page}
        totalPages={totalPages}
        setCurrentPage={handlePageChange}
        totalEntries={totalEntries}
        pageSize={pageSize}
      />
      <ConfirmationATM
        show={showDeleteModal}
        onClose={() => {
          setShowDeleteModal(false);
          setSelectedUser("");
        }}
        onConfirm={confirmDelete}
        message={`Are you sure you want to delete ${selectedUser?.name} ?`}
      />
    </div>
  );
};

export default RestaurantCategoryTable;
